namespace TabAurous.Retail {
    export interface POSSalesItemsForm {
        TransId: Serenity.StringEditor;
        TransItemId: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        DesignId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ProductCode: Serenity.StringEditor;
        DesignCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        StampId: Serenity.LookupEditor;
        ProductSizeId: CommonProductSizeLookup;
        HasBom: Serenity.BooleanEditor;
        MetalId: Serenity.LookupEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        Purity: PurityEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        HUID: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        DepartmentId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        Pieces: PiecesEditor;
        ExportPieces: PiecesEditor;
        Weight: WeightEditor;
        PureWeight: WeightEditor;
        NetWeight: WeightEditor;
        UnitRate: AmountEditor;
        MetalAmount: AmountEditor;
        StonePieces: PiecesEditor;
        StoneWeight: WeightEditor;
        StoneRate: AmountEditor;
        StoneAmount: AmountEditor;
        DiamondPieces: PiecesEditor;
        DiamondWeight: WeightEditor;
        DiamondAmount: AmountEditor;
        OtherPieces: PiecesEditor;
        OtherWeight: WeightEditor;
        OtherRate: AmountEditor;
        OtherAmount: AmountEditor;
        NetAmount: AmountEditor;
        UnitLabour: AmountEditor;
        FancyCharges: AmountEditor;
        OtherCharges: AmountEditor;
        GrossAmount: AmountEditor;
        CCGrossAmount: AmountEditor;
        CCNetAmount: AmountEditor;
        MF: AmountEditor;
        MFAmount: AmountEditor;
        UnitCost: Serenity.DecimalEditor;
        DiscountPer: Serenity.DecimalEditor;
        Discount: AmountEditor;
        WstPer: Serenity.DecimalEditor;
        WstWt: Serenity.DecimalEditor;
        IsDisabled: Serenity.BooleanEditor;
        ServerDate: Serenity.DateEditor;
        RefTransItemId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        SpecialRemark: Serenity.StringEditor;
        UserDescription: Serenity.StringEditor;
        AckStatus: Serenity.IntegerEditor;
        DeliveryDate: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        BagStatus: Serenity.StringEditor;
        CostMethodId: Serenity.LookupEditor;
        ImageName: Serenity.ImageUploadEditor;
        BOMDetails: POSSalesItemsBOMEditor;
        LaborDetails: POSSalesLaborEditor;
    }

    export class POSSalesItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSSalesItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSSalesItemsForm.init)  {
                POSSalesItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonProductSizeLookup;
                var w5 = s.BooleanEditor;
                var w6 = PurityEditor;
                var w7 = StoneSieveLookup;
                var w8 = PiecesEditor;
                var w9 = WeightEditor;
                var w10 = AmountEditor;
                var w11 = s.DecimalEditor;
                var w12 = s.DateEditor;
                var w13 = s.ImageUploadEditor;
                var w14 = POSSalesItemsBOMEditor;
                var w15 = POSSalesLaborEditor;

                Q.initFormType(POSSalesItemsForm, [
                    'TransId', w0,
                    'TransItemId', w0,
                    'VoucherTypeId', w1,
                    'PartyId', w1,
                    'BagNo', w0,
                    'SKU', w0,
                    'ItemTypeId', w1,
                    'ProductId', w0,
                    'DesignId', w0,
                    'ProductTypeId', w2,
                    'ProductCode', w0,
                    'DesignCode', w0,
                    'ProductName', w0,
                    'AttributeId', w0,
                    'CategoryId', w3,
                    'SubCategoryId', w2,
                    'BrandId', w2,
                    'SuperTypeId', w2,
                    'CollectionId', w2,
                    'StampId', w2,
                    'ProductSizeId', w4,
                    'HasBom', w5,
                    'MetalId', w2,
                    'Attribute', w0,
                    'KaratId', w2,
                    'Purity', w6,
                    'MetalColorId', w2,
                    'ShapeId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'StoneSizeId', w2,
                    'SieveId', w7,
                    'GroupSieveId', w7,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w0,
                    'StoneDepth', w0,
                    'LotNo', w0,
                    'Lab', w2,
                    'CertificateNo', w0,
                    'Hallmark', w2,
                    'HUID', w0,
                    'CalcOnId', w2,
                    'CalcUnitId', w2,
                    'HSN', w2,
                    'TaxCode', w2,
                    'DepartmentId', w1,
                    'Line_No', w0,
                    'RefNo', w0,
                    'Pieces', w8,
                    'ExportPieces', w8,
                    'Weight', w9,
                    'PureWeight', w9,
                    'NetWeight', w9,
                    'UnitRate', w10,
                    'MetalAmount', w10,
                    'StonePieces', w8,
                    'StoneWeight', w9,
                    'StoneRate', w10,
                    'StoneAmount', w10,
                    'DiamondPieces', w8,
                    'DiamondWeight', w9,
                    'DiamondAmount', w10,
                    'OtherPieces', w8,
                    'OtherWeight', w9,
                    'OtherRate', w10,
                    'OtherAmount', w10,
                    'NetAmount', w10,
                    'UnitLabour', w10,
                    'FancyCharges', w10,
                    'OtherCharges', w10,
                    'GrossAmount', w10,
                    'CCGrossAmount', w10,
                    'CCNetAmount', w10,
                    'MF', w10,
                    'MFAmount', w10,
                    'UnitCost', w11,
                    'DiscountPer', w11,
                    'Discount', w10,
                    'WstPer', w11,
                    'WstWt', w11,
                    'IsDisabled', w5,
                    'ServerDate', w12,
                    'RefTransItemId', w0,
                    'RefTransId', w0,
                    'Remark', w0,
                    'SpecialRemark', w0,
                    'UserDescription', w0,
                    'AckStatus', w1,
                    'DeliveryDate', w12,
                    'CompanyId', w1,
                    'BagStatus', w0,
                    'CostMethodId', w2,
                    'ImageName', w13,
                    'BOMDetails', w14,
                    'LaborDetails', w15
                ]);
            }
        }
    }
}
